/**
 * A board pages a column rather than reading it whole, so `shown` is often less
 * than `total`: the label says both while they differ and collapses to one
 * number once the column has caught up.
 */
export function columnCountLabel(shown: number, total: number): string {
  const safeShown = Math.max(0, shown)
  const safeTotal = Math.max(0, total)
  return safeShown >= safeTotal
    ? safeTotal.toLocaleString(`en-US`)
    : `${safeShown.toLocaleString(`en-US`)} of ${safeTotal.toLocaleString(`en-US`)}`
}
